<template>
  <v-container fluid class="futuristic-container">
    <v-card flat class="futuristic-card">
      <div class="card-header">
        <h4 class="earth-color">ADD CHANGELOG</h4>
        <div class="title-decoration"></div>
      </div>
      <v-container>
        <v-form @submit.prevent="postChangeLog()">
          <v-text-field
            label="Version"
            v-model="changelog.version"
            :rules="requiredRules"
            hint="Start with letter V."
            required
            class="futuristic-input"
          ></v-text-field>
          <br/>
          <label class="earth-color">Description</label>
          <vue-editor
            :rules="requiredRules"
            v-model="changelog.description"
            class="futuristic-editor"
          ></vue-editor>
          <v-btn depressed color="#587e27" class="futuristic-btn action-btn" block type="submit"
            >Add Changelog</v-btn
          >
        </v-form>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import { VueEditor } from "vue2-editor";
export default {
  data() {
    return {
      requiredRules: [v => !!v || "This field is required"],
      changelog: {
        version: "V",
        description: "",
        session_id: localStorage.getItem("lkjhgfdsa")
      }
    };
  },

  components: {
    VueEditor
  },
  methods: {
    postChangeLog: function() {
      this.$store.dispatch("loading_true");
      this.$store.dispatch("post_change_log", this.changelog);
    }
  }, 

};
</script>

<style scoped>
.futuristic-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.futuristic-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  overflow: hidden;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 1.2rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
  color: white;
  margin-top: 20px;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.action-btn {
  margin: 4px;
}

.futuristic-editor {
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  padding: 10px;
  margin-top: 8px;
  background: #f5f7fa;
}

/* Style the VueEditor to match the futuristic theme */
.futuristic-editor >>> .ql-container {
  border: none !important;
  font-size: 16px;
}

.futuristic-editor >>> .ql-toolbar {
  border: none !important;
  border-bottom: 1px solid #e0e0e0 !important;
  background: #f9f9f9;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.futuristic-editor >>> .ql-editor {
  min-height: 200px;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .futuristic-container {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.1rem;
  }
}

@media (max-width: 600px) {
  .futuristic-container {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1rem;
  }
}
</style>